import RouterPath from 'libs/RouterPath';

const createStep = (target, title, content, placement, href) => ({
	target,
	title,
	content,
	href,
	placement,
	disableBeacon: true,
})

export default [
	createStep('.test-step', 'Tytuł 1', 'This is my awesome feature! 1', 'bottom'),
	createStep('.test-step-2', 'Tytuł 2', 'This is my awesome feature! 2', 'left', RouterPath.BUYER_INIT),
	createStep('.tour-stepper', 'Tytuł 3', 'This is my awesome feature! STEPPER', 'right'),
]